export default "__VITE_ASSET__BUZWKACA__"